<template>
  <div v-loading="loading" class="el-container">
<!--    <div style="width: 100%;height: 900px;">-->
<!--      <iframe  style="width: 100%;height: 900px;" src="http://192.168.6.79:8080/#/shunDianCloud"></iframe>-->
<!--    </div>-->
    <img class="nesc_nd1_li" :src="require('../assets/image/agent.jpg')">
    <div class="form-container">
      <div class="flex-column-left text-join animate__animated animate__fadeInUp">
        <h1>{{ $t('lang.joinUs') }}</h1>
        <div class="flex-column-left">
          <p>{{ $t('lang.contactPhone') }}</p>
          <p>400-835-9997</p>
        </div>
        <div class="flex-column-left">
          <p>{{ $t('lang.address') }}</p>
          <p>{{ $t('lang.addressInfo') }}</p>
        </div>
      </div>
      <!-- pc端显示 -->
      <el-form ref="dataForm" :rules="rules" :model="temp" class="form-content pc">
        <el-form-item class="firstline">
          <el-form-item prop="PersonName" style="flex: 1">
            <el-input v-model="temp.PersonName" :placeholder="'* ' + $t('lang.PersonName')" maxlength="11" />
          </el-form-item>
          <el-radio-group v-model="temp.Sex" style="padding-left: 10px;padding-right: 10px">
            <el-radio label="1">{{ $t('lang.SexMan') }}</el-radio>
            <el-radio label="2">{{ $t('lang.SexWoman') }}</el-radio>
          </el-radio-group>
          <el-form-item prop="Mobile" style="flex: 1">
            <el-input v-model="temp.Mobile" :placeholder="'* ' + $t('lang.phone')" maxlength="11" />
          </el-form-item>
        </el-form-item>
        <el-form-item prop="Comments">
          <el-input v-model="temp.Comments" :placeholder="'* ' + $t('lang.Comments')" type="textarea" maxlength="200" />
        </el-form-item>
        <el-form-item :label="'*' + $t('lang.CooperArea')" class="flex-row-left">
          <el-form-item prop="SelectProvince">
            <el-select key="ProvinceName" v-model="temp.SelectProvince" :placeholder="$t('lang.Province')">
              <el-option
                v-for="item in provinces"
                :key="item.value"
                size="small"
                :label="item.label"
                :value="item.value"
                @click.native="changeProvince()"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="SelectCity">
            <el-select key="CityName" v-model="temp.SelectCity" :placeholder="$t('lang.City')">
              <el-option
                v-for="item in cities"
                :key="item.value"
                size="small"
                :label="item.label"
                :value="item.value"
                @click.native="changeCity"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select key="AreaName" v-model="temp.SelectArea" :placeholder="$t('lang.Area')">
              <el-option
                v-for="item in area"
                :key="item.value"
                size="small"
                :label="item.label"
                :value="item.value"
                @click.native="changeArea"
              />
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item :label="'* ' + $t('lang.InvestBudget')" class="flex-row-left">
          <el-form-item prop="InvestFlag">
            <el-radio-group v-model="temp.InvestFlag">
              <el-radio-button v-for="item in yusuanConfigs" :key="item.Id" :label="item.Id">{{ item.Text }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form-item>
        <el-form-item style="margin-top: 40px" prop="readPrivate">
          <div class="flex-row-left">
            <el-checkbox v-model="readPrivate" style="padding-right: 10px" />
            {{ $t('lang.hasRead') }}&nbsp;<el-link type="primary" @click="showPrivate">{{ $t('lang.privatePolicy') }}</el-link>
          </div>
          <el-button style="width: 100%;height: 48px;color: #ffffff;background: #EB6100" @click="submit">{{ $t('lang.submit') }}</el-button>
          <div class="text-private">{{ $t('lang.privatePolicy1') }}</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { regionData } from 'element-china-area-data'
import * as util from '../utils/util'
export default {
  name: 'Agent',
  components: {
  },
  data() {
    return {
      lang: '',
      textShow: false,
      readPrivate: false,
      provinces: regionData,
      cities: [],
      area: [],
      yusuanConfigs: [],
      loading: true,
      temp: {
        PersonName: '',
        Sex: '1',
        Mobile: '',
        Comments: '',
        ProvinceName: '',
        CityName: '',
        AreaName: '',
        SelectProvince: null,
        SelectCity: null,
        SelectArea: null,
        InvestFlag: ''
      },
      rules: {
        PersonName: [{ required: true, trigger: 'blur', validator: (rule, value, callback) => {
          if (util.validEmpty(value)) {
            callback(new Error(this.lang !== 'en' ? '请填入姓名!' : 'Please fill in your name!'))
          } else {
            callback()
          }
        } }],
        Mobile: [{ required: true, trigger: 'blur', validator: (rule, value, callback) => {
          if (util.validEmpty(value)) {
            callback(new Error(this.lang !== 'en' ? '请填入手机号!' : 'Please fill in your iphone!'))
          } else if (/^1[12345789]\d{9}$/.test(value) == false) {
            callback(new Error(this.lang !== 'en' ? '请输入正确手机号!' : 'Please fill in right iphone'))
          } else {
            callback()
          }
        } }],
        Comments: [{ required: true, trigger: 'blur', validator: (rule, value, callback) => {
          if (util.validEmpty(value)) {
            callback(new Error(this.lang !== 'en' ? '请填入从事行业信息!' : 'Please fill in your relevant industry information!'))
          } else {
            callback()
          }
        } }],
        SelectProvince: [{ required: true, trigger: 'change', validator: (rule, value, callback) => {
          if (util.validEmpty(value)) {
            callback(new Error(this.lang !== 'en' ? '请选择合作省份!' : 'Please select a cooperProvince!'))
          } else {
            callback()
          }
        } }],
        SelectCity: [{ required: true, trigger: 'change', validator: (rule, value, callback) => {
          if (util.validEmpty(value)) {
            callback(new Error(this.lang !== 'en' ? '请选择合作城市!' : 'Please select a cooperCity!'))
          } else {
            callback()
          }
        } }],
        InvestFlag: [{ required: true, trigger: 'blur', validator: (rule, value, callback) => {
          if (util.validEmpty(value)) {
            callback(new Error(this.lang !== 'en' ? '请选择投入预算!' : 'Please select a budget!'))
          } else {
            callback()
          }
        } }]
      }
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {
    const lang = window.sessionStorage.getItem('language')
    this.lang = lang
    this.getConfig()
  },
  updated() {},

  destroyed() {},

  methods: {
    getConfig() {
      this.$http.post(this.isDevelop ? '/ZhaoShangService/InvestSource' : '/api/ZhaoShangService/InvestSource', {}).then(
        ({ data }) => {
          this.yusuanConfigs = data.Data
          this.loading = false
        }
      ).catch(function() {
      })
    },
    showPrivate() {
      window.open(`https://sundn.cn/upload/file/private.html`)
    },
    handleConfirm() {
      this.readPrivate = true
    },
    changeProvince() {
      this.cities = []
      this.area = []
      this.temp.SelectCity = null
      this.temp.SelectArea = null
      this.temp.CityName = ''
      this.temp.AreaName = ''
      const cityItem = this.provinces.filter((item) => item.value === this.temp.SelectProvince)
      if (cityItem[0]) {
        this.cities = cityItem[0].children
        this.temp.ProvinceName = cityItem[0].label
      }
    },
    changeCity() {
      this.area = []
      this.temp.SelectArea = null
      this.temp.AreaName = ''
      const areaItem = this.cities.filter((item) => item.value === this.temp.SelectCity)
      if (areaItem[0]) {
        this.area = areaItem[0].children
        this.temp.CityName = areaItem[0].label
      }
    },
    changeArea() {
      const area = this.area.filter((item) => item.value === this.temp.SelectArea)
      if (area[0]) {
        this.temp.AreaName = area[0].label
      }
    },
    submit() {
      console.log(this.lang)
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          console.log(this.temp)
          if (!this.readPrivate) {
            this.$message({
              title: '提示',
              message: '请先阅读并同意瞬电科技官方网站隐私政策！',
              type: 'warning'
            })
            return
          }
          this.$http.post(this.isDevelop ? '/ZhaoShangService/Create' : '/api/ZhaoShangService/Create', this.temp).then(
            this.$message({
              title: '成功',
              message: '已提交',
              type: 'success'
            }),
            location.reload()
          ).catch(function() {
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
/*按钮点击*/
.el-button:focus {
  background: #EB6100 !important;
  border-color: #EB6100;
  color: white !important;
}
.el-form {
  border: 1px solid #222222;
  background: rgba(245,245,245,0.7);
  box-sizing: border-box;
  padding: 40px 20px;
  .text-private {
    color: #666666;
    font-weight: 400;
    font-size: 0.833333vw;
    margin-top: 1.041667vw;
    line-height: normal;
  }
  .firstline {
    .el-form-item__content {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  @media screen and (max-width: 1920px) {
    width: 700px;
  }
  @media screen and (max-width: 1466px) {
    width: 650px;
  }
  @media screen and (max-width: 1200px) {
    width: 550px;
  }
  @media screen and (max-width: 992px) {
    width: 90%;
    margin-left: 5%;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  @media screen and (max-width: 768px) {
    padding: 10px 5px;
    border: none;
    width: 100%;
    margin-left: 0;
    margin-top: 10px;
    margin-bottom: 10px;
  }
}

@media screen and (max-width: 768px) {
  .el-form-item {
    flex-direction: column !important;
    align-items: flex-start;
  }
  .firstline {
    .el-form-item__content {
      width: 100%;
      .el-radio-group {
        padding-top: 10px;
      }
    }
    .el-form-item {
      width: 100%;
    }
  }
}

.el-form-item.flex-row-left .el-form-item__content {
  display: flex;
  flex: 1;
}
.el-form-item__label {
  color: #000000;
  width: 110px;
  text-align: left;
}

// 修改radio框选中的颜色
.el-radio__input.is-checked + .el-radio__label {
  color: #EB6100 !important;
}
.el-radio__inner:hover{
  border-color: #EB6100 !important;
}
.el-radio__input.is-checked .el-radio__inner {
  background: #EB6100 !important;
  border-color: #EB6100 !important;
}
// 投入预算radio-button
.el-radio-button__orig-radio:checked+.el-radio-button__inner {
  background-color: #EB6100;
  border-color: #EB6100;
}
.el-radio-button__inner:hover {
  color: #EB6100;
}
.el-radio-button.is-active .el-radio-button__inner {
  background-color: #EB6100;
  border-color: #EB6100;
  box-shadow: -1px 0 0 0 #EB6100;
}
// 行业textarea
.el-textarea__inner {
  height: 70px;
}
.el-input.is-active .el-input__inner, .el-input__inner:focus {
  border-color: #EB6100 !important;
}
.el-textarea.is-active .el-textarea__inner, .el-textarea__inner:focus {
  border-color: #EB6100 !important;
}
</style>

<style scoped lang="scss">
.el-container {
  position: relative;
}
.nesc_nd1_li {
  position: relative;
  height: calc(100vh - 64px);
  @media screen and (max-width: 992px) {
    height: auto;
  }
}

.form-container {
  .text-join {
    color: #ffffff;
    h1 {
      font-size: 42px;
    }
    div {
      margin-top: 60px;
      font-size: 20px;
      p:last-of-type {
        padding-top: 10px;
      }
    }
  }
  @media screen and (min-width: 992px) {
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: absolute;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  @media screen and (max-width: 991px) {
    .text-join {
      color: #000000;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      padding-top: 20px;
      padding-bottom: 20px;
      h1 {
        font-size: 30px;
      }
      div {
        margin-top: 0;
        font-size: 16px;
        p:last-of-type {
          padding-top: 8px;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    .text-join {
      color: #000000;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      padding-top: 10px;
      padding-bottom: 10px;
      h1 {
        font-size: 20px;
      }
      div {
        margin-top: 0;
        font-size: 13px;
        p:last-of-type {
          padding-top: 8px;
        }
      }
    }
  }
}

</style>
